import { useSiteConfig } from "@/context/SiteConfigContext";

const MSG = {
  fr: "Bonjour, je vous contacte au sujet d'un projet.",
  it: "Buongiorno, vi contatto per un progetto.",
  en: "Hello, I'm reaching out about a project.",
};

// Floating click-to-chat WhatsApp button. Shown only when a number is configured.
export const WhatsAppButton = ({ lang = "fr" }) => {
  const { config } = useSiteConfig();
  const num = (config.whatsapp || "").replace(/[^\d]/g, "");
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent(MSG[lang] || MSG.fr)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] shadow-xl transition-transform duration-300 hover:scale-110 focus:scale-110"
    >
      <svg viewBox="0 0 32 32" width="30" height="30" fill="#ffffff" aria-hidden="true">
        <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.593 4.463 1.72 6.404L3.2 28.8l6.57-1.717a12.74 12.74 0 0 0 6.234 1.62h.005c7.06 0 12.8-5.74 12.8-12.8s-5.744-12.703-12.805-12.703zm0 23.04h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.006 1.048 1.07-3.9-.252-.4a10.56 10.56 0 0 1-1.62-5.628c0-5.867 4.774-10.64 10.64-10.64 2.842 0 5.513 1.108 7.52 3.12a10.56 10.56 0 0 1 3.115 7.523c0 5.867-4.773 10.64-10.636 10.64zm5.833-7.967c-.32-.16-1.89-.933-2.184-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.987-2.374-.26-.623-.523-.539-.72-.549l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.824.763.33 1.36.527 1.824.674.767.244 1.464.21 2.016.127.615-.092 1.89-.773 2.157-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
    </a>
  );
};
